import { FC, useMemo } from "react";
import { useFormikContext } from "formik";
import { Box, Typography } from "@mui/material";
import {
  ContentSectionLayout,
  TwoColsLayout,
  types
} from "@vilocnv/allsetra-core";

// Data
import { useAppSelector } from "hooks";
import { selectAccountsState } from "app/data/selectors";
import { useTranslation } from "react-i18next";

const ManagementForm: FC = () => {
  const { values } = useFormikContext<types.IAccount>();

  const { allAccounts } = useAppSelector(selectAccountsState);

  const { t } = useTranslation(["translation", "formFieldsTranslation"]);

  const { updatedByName, createdByName } = useMemo(() => {
    const updatedByName = allAccounts.find(
      (acc: types.IAccount) => acc.uniqueId === values.updatedBy
    )?.name;
    const createdByName = allAccounts.find(
      (acc: types.IAccount) => acc.uniqueId === values.createdBy
    )?.name;

    return {
      updatedByName: updatedByName ?? "N/A",
      createdByName: createdByName ?? "N/A"
    };
  }, [allAccounts, values.updatedBy, values.createdBy]);

  return (
    <ContentSectionLayout
      title={t("titles.management")}
      subTitle={t("descriptions.management")}
      hideDivider
    >
      <Box
        sx={{
          marginTop: {
            xs: "32px",
            md: "0px"
          }
        }}
      >
        <TwoColsLayout>
          <Typography variant={"subtitle2"}>
            {t("createdBy.label", { ns: "formFieldsTranslation" })}
          </Typography>
          <Typography variant={"subtitle2"} textAlign={"right"}>
            {createdByName}
          </Typography>
        </TwoColsLayout>
        <TwoColsLayout hideDivider>
          <Typography variant={"subtitle2"}>
            {t("modifiedBy.label", { ns: "formFieldsTranslation" })}
          </Typography>
          <Typography variant={"subtitle2"} textAlign={"right"}>
            {updatedByName}
          </Typography>
        </TwoColsLayout>
      </Box>
    </ContentSectionLayout>
  );
};

export default ManagementForm;
